import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-pa-lg row justify-center" };
const _hoisted_2 = { class: "q-pa-md" };
const _hoisted_3 = { class: "entry-check-table" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_badge = _resolveComponent("q-badge");
    const _component_q_input = _resolveComponent("q-input");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "full-width" }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, { class: "col-12 col-xl-10 col-lg-10 col-md-10" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                    _createElementVNode("div", { class: "text-h4 text-bold text-green-7" }, "パスワード再発行", -1)
                                ]))]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "table-caption" }, [
                                        _createTextVNode(" 登録済のメールアドレスを入力し、送信ボタンを押してください。"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" 新しいパスワードを発行するための認証コードをお送りします。 ")
                                    ], -1)),
                                    _createElementVNode("table", _hoisted_3, [
                                        _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, [
                                                    _cache[4] || (_cache[4] = _createTextVNode("メールアドレス ", -1)),
                                                    _createVNode(_component_q_badge, {
                                                        color: "red-9",
                                                        align: "middle"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                                                _createTextVNode("必須", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createVNode(_component_q_input, {
                                                        modelValue: _ctx.data.mailAddress,
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.data.mailAddress) = $event)),
                                                        color: "positive",
                                                        outlined: "",
                                                        "bottom-slots": "",
                                                        dense: "",
                                                        error: _ctx.valid.mailAddress.error,
                                                        "error-message": _ctx.valid.mailAddress.message
                                                    }, null, 8, ["modelValue", "error", "error-message"])
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg row",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    label: "戻る",
                                    class: "btn-route col-5 col-md-3",
                                    color: "grey-8",
                                    icon: "navigate_before",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$router.push({ name: 'login' })))
                                }),
                                _createVNode(_component_q_btn, {
                                    label: "送信",
                                    class: "btn-route col-5 col-md-3",
                                    color: "green-7",
                                    "icon-right": "navigate_next",
                                    onClick: _ctx.submit
                                }, null, 8, ["onClick"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_section, { class: "row justify-center text-center" }, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                    _createElementVNode("div", { class: "q-pa-md annotation-text" }, [
                                        _createElementVNode("div", { style: { "text-align": "left" } }, [
                                            _createTextVNode(" ご連絡事項"),
                                            _createElementVNode("br"),
                                            _createTextVNode(" こちらのページから再発行できるのは、"),
                                            _createElementVNode("strong", null, "入居者様向けマイページのパスワード"),
                                            _createTextVNode("となります。"),
                                            _createElementVNode("br"),
                                            _createElementVNode("strong", null, "ミニミニマイページのID・パスワード"),
                                            _createTextVNode("をご利用の方は、"),
                                            _createElementVNode("strong", null, "ミニミニマイページからパスワード再発行手続き"),
                                            _createTextVNode("を行ってください。 ")
                                        ]),
                                        _createElementVNode("a", {
                                            href: "https://minimini.jp/customer",
                                            target: "_blank",
                                            rel: "noopener noreferrer"
                                        }, "ミニミニマイページはこちら")
                                    ], -1)
                                ]))]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
